import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const PRODUCTADDPAGE_LEGACY_FIELD_ORDER = [
  
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  productAddPageDescriptor: _generatedProductAddPageDescriptor,
  productAddPageBlocDefinition,
  productAddPageDashboardLayout,
  productAddPageConfig,
  productAddPageResolveConfig,
  productAddPageProperties,
} = doodBlockConfig(
  {
    name: "Product add page",
    internal_name: "Product add page",
    url: "products/:shopId/:productId",
    defaultParent: [/^Cart page$/i, /^Shop page$/i],
    componentType: 'ProductAddPageComponent',
    category: 'page',
    description: "Product add page.",
    keywords: [],
    isRootBlock: true,
    sharedFields: {}
,
    slots: [
      {
        key: 'body',
        name: "pages.blocks.product-add-page.body.label",
        accept: 'explicitOnly',
        allowedTypes: [".*(?<!Page)"],
        slotItemFormat: 'ids',
      },
      {
        key: 'footer',
        name: "pages.blocks.product-add-page.footer.label",
        accept: 'explicitOnly',
        allowedTypes: ["BigFooterBlock", "LegalsFooterBlock", "HtmlBlock"],
        slotItemFormat: 'ids',
      }
    ]
  },

  () => ({
    // no scalar props
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: ["body", "footer"],
          },
        ],
      },
    ],
  })
);

export function productAddPageDescriptor(): IBlockDescriptor;
export function productAddPageDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function productAddPageDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedProductAddPageDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedProductAddPageDescriptor, productAddPageProperties, fieldOrder);
}

export {
  productAddPageBlocDefinition,
  productAddPageDashboardLayout,
  productAddPageProperties,
  productAddPageConfig,
  productAddPageResolveConfig,
};

export type ProductAddPageConfig = typeof productAddPageConfig;
